/**
 * English for the org's plan (card S11b): the meters and features of the
 * catalog (vibe-infra catalog/products/tracker.yaml) in a buyer's words, the
 * line a refusal turns into, and the first steps of an empty org. Spread into
 * `en`, so `ru.plan.ts` must cover every key.
 */
export const enPlan = {
  "plan.meter.tracker.campaigns": "Campaigns",
  "plan.meter.tracker.domains": "Domains",
  "plan.feature.tracker.reports.custom": "Custom reports — saved views and formulas",
  "plan.feature.tracker.postbacks.s2s": "Partner S2S postbacks",
  "plan.usage": "{meter}: {used} of {limit} on your plan",
  "plan.usage.full": "{meter}: {used} of {limit} — the plan's limit is reached",
  "plan.increase": "Increase",
  "plan.billing": "Plan and billing",
  "plan.connect": "Connect",
  "plan.refusal.limit": "The plan's limit is reached: {meter} — {limit}",
  "plan.refusal.limitPlain": "The plan's limit is reached: {meter}",
  "plan.refusal.limit.hint": "Increase the plan to add more — nothing you entered is lost.",
  "plan.refusal.feature": "«{feature}» is not in your plan",
  "plan.refusal.feature.hint": "It is available on a higher plan — open Plan and billing.",
  "plan.refusal.product": "{product} is not connected to the organization",
  "plan.refusal.suspended": "The organization is suspended — products are closed until it is paid",
  "plan.refusal.ambiguous": "Pick an organization to go on",
  "plan.refusal.lockedBySource": "The campaign is managed in an external source",
  "onb.domain": "A domain for ad links",
  "onb.domain.todo": "The ad link lives on your domain: connect one you own with a CNAME record, or buy one and connect it.",
  "onb.domain.done": "{fqdn} — {state}",
  "onb.domain.own": "My own domain",
  "onb.domain.buy": "Buy a domain",
  "onb.buy.title": "Buy a domain",
  "onb.buy.body": "Buy a domain at any registrar, or take a subdomain of a domain you already own (go.example.com). Then connect it here: the tracker shows the CNAME record to put at your DNS host and checks it every minute.",
  "onb.buy.connect": "I have it — connect",
  "onb.campaign": "First campaign",
  "onb.campaign.todo": "A source, an offer and the domain — the editor walks you through it and ends on the ad link.",
  "onb.campaign.create": "Create a campaign",
  "onb.readOnly": "Ask an admin of the organization to connect the first domain.",
};
